import { lazy } from 'react';

import TryIntent from '@/components/try-intent/src/try-intent';
import { useProductIntent } from '@/components/user-context/helpers/use-product-intent';
import {
	defaultFeatureFlags,
	defaultLabels,
	defaultProductData,
	firstImpressionsImageUrls,
} from '@/templates/try/cloud/signup/signup-page/src/utils/data-mappings';
import { getQueryParams } from '@/templates/try/cloud/signup/signup-page/src/utils/query-param-resolver';
import { useLabelsLocalized } from '@/templates/try/cloud/signup/signup-page/src/utils/use-labels-localized';
import { ClientOnly } from '@/utils/client-only';
import { useLocation } from '@/utils/location-provider';

const SignUpLayoutContainer = lazy(
	() =>
		import('../../../../../../../components/signup/bxpkit-signup/src/sign-up-layout-container.tsx'),
);

export const SignupDefault = () => {
	const location = useLocation();
	const labels = useLabelsLocalized(defaultLabels);
	const { layout } = getQueryParams(location?.search ?? '');
	const { bundle, edition } = useProductIntent(location.href);

	const signup = (
		// @ts-expect-error missing attributes
		<SignUpLayoutContainer
			layout={layout}
			allowSignupWithGoogle={true}
			allowSignupWithAllSocialOptions={true}
			bundleOverride={bundle}
			editionOverride={edition}
			productData={defaultProductData}
			enableFreeBreachTest={true}
			labels={labels}
			firstImpressionsImageUrls={firstImpressionsImageUrls}
			featureFlags={defaultFeatureFlags}
		/>
	);

	return (
		<ClientOnly>
			<TryIntent intentType="form" productKey={bundle} edition={edition}>
				{signup}
			</TryIntent>
		</ClientOnly>
	);
};
